function radToDeg(radians) {
    return Math.round(radians * (180 / Math.PI));
}

export default radToDeg;
